import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { ServicesProvider } from 'src/providers/services';
import { FileUploadService } from 'src/providers/upload';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { DomSanitizer } from "@angular/platform-browser";
import { AddCall } from 'src/providers/addvCall';
@Component({
  selector: 'app-addmem',
  templateUrl: './addmem.page.html',
  styleUrls: ['./addmem.page.scss'],
})
export class AddmemPage implements OnInit {

  getMemName: any;
  getMemGender: any;
  getMemReletion: any;
  getMemHeight: any;
  getMemWeight: any;
  getMemMobileNo: any;
  getMemDob: any;
  memProImg: any = "";
  selectedDate: any;
  membDOB: any;
  reletionList = [];
  today: any;
  Date: any = null;
  setDate: string;
  PatientProfileImage: any;
  CameraFileUpload: boolean;
  disbaleButton : boolean; 
  constructor(
    public toastCtrl: ToastController,
    public services: ServicesProvider,
    public modalCtrl: ModalController,
    public _modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    public fileupload: FileUploadService,
    private datePipe: DatePipe,
    public sanitizer: DomSanitizer,
    public addCall: AddCall,
  ) { }

  ngOnInit() { 
    this.today = new Date().toISOString().split('T')[0];
  }

  ionViewWillEnter() {
    this.today = new Date().toISOString().split('T')[0];
    this.memProImg = "/assets/img/face.png";
    this.fileupload.setfilepath("");
    this.getPatientReletion();
    this.selectedDate = "";
    this.membDOB = "";
    this.PatientProfileImage = "";
    this.disbaleButton = false;
  }


  arabDOB: any;

  validateDate(event: any) {
    debugger
    const selectedDate = event.target.value;
    console.log('Selected Date:', selectedDate);
    console.log('Today Date:', this.today);
    
    if (selectedDate > this.today) {
      this.presentToast("Future date is not acceptable");
      event.target.value = this.today; // Set input value to today's date
    }
  }

  async openDatePicker3(event) {
    if (this.addCall.selectedLanguage == 'ea') {
      let inputDateString = event.target.value;
      let date = new Date(inputDateString);
      this.arabDOB = { month: 'long' };
      let formattedMonth = new Intl.DateTimeFormat('ar-EG', this.arabDOB).format(date);
      let dayYearParts = inputDateString.split('-');
      let day = dayYearParts[2];
      let year = dayYearParts[0].toString().substr(-2);
      this.membDOB = `${day}-${formattedMonth}-${year}`;
      this.getMemDob = event.target.value;
      console.log("arab", this.membDOB);
    } else {
      this.membDOB = this.datepipeTransform(new Date(event.target.value), "dd MMM yy");
      this.getMemDob = event.target.value;
      console.log(this.membDOB, "this.membDOB");
    }
  }

  getToday(): any {
    return new Date().toISOString().split('T')[0]
  }

  async AlertInfo(msg, status) {
    const alert = await this._modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      componentProps: {
        'msg': msg,
        'sts': status,
      }
    });
    await alert.present();
  }

  async presentToast(msg) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }

    let Value;
    switch (callFor) {
      case "Time":
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(":");
        let H = +String(Value).substr(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = (H < 12 || H === 24) ? "AM" : "PM";
        let timeString = h + String(Value).substr(hourEnd, 3) + " " + ampm;
        return timeString;
      case "Date":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
      case "DateTime":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
      case "Date1":
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy")
        } else {
          let dateCall = new Date(dateTime);
          let months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          let arDate = dateCall.getDate() + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  async uploadPhoto(event) {
    this.PatientProfileImage = "";
    const formData = new FormData();
    this.CameraFileUpload = true;
    formData.append('module_id', "66");
    formData.append('file', event.target.files[0]);
    formData.append('pathLocation', "PROFILE/");

    this.services.imageUploadS3Bucket("admin/awsS3FileUpload", formData).subscribe( response => {
      console.log("resposeeehhhhhuploadimageblobToBinary", response);
      this.memProImg = response.filepath.Location;
      this.PatientProfileImage = response.filepath.privatePathUrl;
      console.log("this.memProImg", this.memProImg);
      setTimeout(async () => {
        this.CameraFileUpload = false;
      }, 500);

    });
  }

  closeSub(frm) {
    this.modalCtrl.dismiss({
      from: frm
    });
  }
  inputValue: string = ''; // This will hold the user's input

  limitInputLength(event) {
    const pattern = /[0-9.,]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  insertMemberDetails() {
    if (
      // this.PatientProfileImage != "" &&
      this.getMemName != "" &&
      this.getMemGender != "" &&
      this.getMemDob != "" &&
      this.getMemReletion != "" &&
      this.getMemHeight != "" &&
      this.getMemWeight != "" &&
      this.getMemMobileNo != ""
    ) {
      this.disbaleButton = true;
      this.insertMember();
    }
    else {
      let value = [
        // {
        //   // "f_Name": "Select Photo",
        //   "f_Name": this.addCall.title540,
        //   "f_value": this.PatientProfileImage
        // },
        {
          // "f_Name": "Enter Name",
          "f_Name": this.addCall.title529,
          "f_value": this.getMemName
        },
        {
          // "f_Name": "Choose Gender",
          "f_Name": this.addCall.title541,
          "f_value": this.getMemGender
        },
        {
          // "f_Name": "Select Date Of Birth",
          "f_Name": this.addCall.title542,
          "f_value": this.getMemDob
        },
        {
          // "f_Name": "Choose Reletion",
          "f_Name": this.addCall.title543,
          "f_value": this.getMemReletion
        },
        {
          // "f_Name": "Enter Height",
          "f_Name": this.addCall.title544,
          "f_value": this.getMemHeight
        },
        {
          // "f_Name": "Enter Weight",
          "f_Name": this.addCall.title545,
          "f_value": this.getMemWeight
        },
        {
          "f_Name": this.addCall.title531,
          "f_value": this.getMemMobileNo
        }
      ];
      for (let item of value) {
        if (item.f_value == "") {
          this.presentToast(this.addCall.title546 + " " + item.f_Name);
          break;
        }
      }
    }
  }









  async insertMember() {
    const loading = await this.loadingCtrl.create({
      // message: 'Loading... please Wait',
      message: this.addCall.title507,
    });
    await loading.present();
    let apiData = JSON.stringify({
      "parentpatientId": localStorage.getItem("patient_id"),
      "patientId": 0,
      "name": this.getMemName,
      // "imagearray": this.fileupload.getfilepath1(),
      "imagearray": this.PatientProfileImage,
      "gender": this.getMemGender,
      "dob": this.getMemDob,
      "relationId": this.getMemReletion,
      "heightcm": this.getMemHeight,
      "weightkg": this.getMemWeight,
      "phoneno": this.getMemMobileNo,
      "modifiedby": localStorage.getItem("patient_id")
    });
    this.services.postRequest("addPatientmemberDetails", apiData).subscribe(async res => {
      console.log(res);
      setTimeout(async () => {
        await loading.dismiss();
      }, 500);
      if (res.status == 1) {
        this.closeSub(2);
        this.AlertInfo(this.addCall.title280, res.status);
      }
      else {
        this.AlertInfo(res.msg, res.status);
      }
    });
  }

  getPatientReletion() {
    this.services.getRequest("getpatientrelation").subscribe(res => {
      this.reletionList = res.data;
    });
  }
  
  numberOnlyValidation(event: any) {
    const pattern = /[0-9.,]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
